import { CommonModule } from '@angular/common';
import { ShowRecursoComponent } from './../Componentes/show-recurso/show-recurso.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatatableModule } from '@basis/angular-components';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { TextMaskModule } from 'angular2-text-mask';
import * as base from 'app/base';
import {BaseCrudNavigationComponent, BasePrestacaoContaComponent} from 'app/base';
import { BaseCrudNavigationProfissionalComponent } from 'app/base/base-crud-navigation-profissional.component';
import {
  FormCalendarComponent,
  FormCheckComponent, FormHiddenComponent, FormHoraComponent,
  FormMaskTestComponent,
  FormMoneyComponent,
  FormMultiSelectComponent,
  FormNumberCEPComponent,
  FormNumberCNPJComponent,
  FormNumberComponent,
  FormNumberCPFComponent, FormNumberRegistroComponent, FormPercentComponent, FormRadioComponent,
  FormSelectComponent, FormSliderComponent, FormSwitchComponent,
  FormTextAreaComponent,
  FormTextComponent,
  TelefoneComponent,
  ValidationComponent
} from 'app/base/base-fields/components';
import { FormEditorComponent } from 'app/base/base-fields/components/editor';
import { BaseHomologacaoComponent } from 'app/Componentes/base-homologacao/base-homologacao.component';
import { DataTablePrestacaoContaComponent } from 'app/Componentes/data-table-prestacao-conta/data-table-prestacao-conta.component';
import { EmailComponent } from 'app/Componentes/email/email.component';
import { EnderecoComponent } from 'app/Componentes/endereco/endereco.component';
import { FieldSetDadosProfissionalComponent } from 'app/Componentes/field-set-dados-profissional/field-set-dados-profissional.component';
import { FuncaoExercidaHomologacaoComponent } from 'app/Componentes/funcao-exercida-homologacao/funcao-exercida-homologacao.component';
import { NotificacaoAtividadesComponent } from 'app/Componentes/notificacao-atividades/notificacao-atividades.component';
import { NotificacaoPrestacaoContasComponent } from 'app/Componentes/notificacao-prestacao-contas/notificacao-prestacao-contas.component';
import { PontuacaoHomologacaoComponent } from 'app/Componentes/pontuacao-homologacao/pontuacao-homologacao.component';
import { PontuacaoTotalResultadosComponent } from 'app/Componentes/pontuacao-total-resultados/pontuacao-total-resultados.component';
import { ProfissionalGerenciarAtividadesComponent } from 'app/Componentes/profissional-gerenciar-atividades/profissional-gerenciar-atividades.component';
import { ResumoCursoComponent } from 'app/Componentes/resumo-curso/resumo-curso.component';
import { ResumoDocenciaComponent } from 'app/Componentes/resumo-docencia/resumo-docencia.component';
import { ResumoEventoComponent } from 'app/Componentes/resumo-evento/resumo-evento.component';
import { ResumoHomologacaoComponent } from 'app/Componentes/resumo-homologacao/resumo-homologacao.component';
import { ResumoJustificativaComponent } from 'app/Componentes/resumo-justificativa/resumo-justificativa.component';
import { DecisaoDeJulgamentoComponent } from 'app/Componentes/decisao-de-julgamento/decisao-de-julgamento';
import { DecisaoDeJulgamentoEventoIndividualComponent } from 'app/Componentes/decisao-de-julgamento-evento-individual/decisao-de-julgamento-evento-individual';
import { TelefoneFormComponent } from 'app/Componentes/telefone/telefone.component';
import { UploadAnexosComponent } from 'app/Componentes/upload-anexos/upload-anexos.component';
import { VisualizarAnexoComponent } from 'app/Componentes/visualizar-anexo-gerenciar-atividade/visualizar-anexo.component';
import { CrudCursoPrestacaoContaComponent, CrudCursoPrestacaoContaEtapa1Component, CrudCursoPrestacaoContaEtapa2Component, CrudCursoPrestacaoContaEtapa3Component, CrudCursoPrestacaoContaEtapa4Component } from 'app/curso-prestacao-conta';
import { CrudEventoPrestacaoContaComponent, CrudEventoPrestacaoContaEtapa1Component, CrudEventoPrestacaoContaEtapa2Component, CrudEventoPrestacaoContaEtapa3Component, CrudEventoPrestacaoContaEtapa4Component, CrudEventoPrestacaoContaEtapa5Component } from 'app/evento-prestacao-conta';
import { FieldSetCapacitadoraComponent } from 'app/field-set-capacitadora/field-set-capacitadora.component';
import { CrudFormacaoAcademicaComponent, CrudFormacaoAcademicaEtapa1Component, CrudFormacaoAcademicaEtapa2Component, FormacaoAcademicaComponent } from 'app/formacao-academica';
import { GerenciarBancaEtapa1Component, GerenciarBancaEtapa2Component } from 'app/gerenciamento-banca';
import { CrudGerenciamentoCapacitadoraComponent, CrudGerenciamentoCapacitadoraEtapa1Component, CrudGerenciamentoCapacitadoraEtapa2Component } from 'app/gerenciamento-capacitadora';
import { GerenciamentoComissaoEtapa1Component, GerenciamentoComissaoEtapa2Component } from 'app/gerenciamento-comissao';
import { CrudGerenciamentoCursoComponent, CrudGerenciamentoCursoEtapa1Component, CrudGerenciamentoCursoEtapa2Component, CrudGerenciamentoCursoEtapa3Component, CrudGerenciamentoCursoEtapa4Component } from 'app/gerenciamento-curso';
import { GerenciamentoCursoExteriorEtapa1Component, GerenciamentoCursoExteriorEtapa2Component } from 'app/gerenciamento-curso-exterior';
import { GerenciamentoPosGraduacaoEtapa1Component, GerenciamentoPosGraduacaoEtapa2Component } from 'app/gerenciamento-pos-graduacao';
import { GerenciamentoProducaoIntelectualEtapa1Component, GerenciamentoProducaoIntelectualEtapa2Component } from 'app/gerenciamento-producao-intelectual';
import { CrudInstrutorComponent, CrudInstrutorEtapa1Component, CrudInstrutorEtapa2Component, InstrutorComponent } from 'app/instrutor';
import { CrudPrestacaoContaComponent, CrudPrestacaoContaEtapa1Component, CrudPrestacaoContaEtapa2Component, CrudPrestacaoContaEtapa3Component } from 'app/prestacao-conta';
import { UnmaskDirective } from 'app/util/appUnmask.directive';
import { NoSanitizePipe } from 'app/util/no-sanitizer.component';
import { CepMaskPipe } from 'app/util/pipe-cep';
import { CnpjMaskPipe } from 'app/util/pipe-cnpj';
import { CpfMaskPipe } from 'app/util/pipe-cpf';
import { NumRegistroMaskPipe } from 'app/util/pipe-num-registro';
import { FormatSelectItemPipe } from 'app/util/pipe-selecao';
import { SelectItemPipe } from 'app/util/pipe-select-item';
import { TelefoneMaskPipe } from 'app/util/pipe-telefone';
import { FileUploadModule } from 'primeng/components/fileupload/fileupload';
import {
  AccordionModule,
  ButtonModule,
  CalendarModule,
  CheckboxModule,
  ConfirmDialogModule,
  DataTableModule,
  DialogModule,
  DropdownModule,
  EditorModule,
  FieldsetModule,
  GrowlModule, InputSwitchModule,
  InputTextareaModule,
  InputTextModule,
  MessagesModule,
  MultiSelectModule,
  RadioButtonModule, SliderModule,
  StepsModule,
  TabViewModule,
} from 'primeng/primeng';
import { UploadExcelComponent } from 'app/Componentes/upload-excel/upload-excel.component';
import { BtnDataTableBasisComponent } from 'app/base/base-fields/components/btn-data-table';
import { ModulosModule } from 'app/modulos/modulos.module';
import { ViewRecursoComponent } from 'app/Componentes/view-recurso/view-recurso.component';
import { AbrirRecursoComponent } from 'app/Componentes/abrir-recurso/abrir-recurso.component';
import { EnviarRecursoComponent } from 'app/Componentes/enviar-recurso/enviar-recurso.component';
import { InterporRecursoComponent } from 'app/Componentes/interpor-recurso/interpor-recurso.component';
import {FormPercentIpcaComponent} from '../base/base-fields/components/percent-ipca';
import {TextBankAccountComponent} from '../base/base-fields/components/textbankaccount';
import {TextMaskBankComponent} from '../base/base-fields/components/textMaskBank';
import {HexadecimalValueValidator} from '../base/base-fields/validators';
import {TipoAtividadeModule} from '../tipo-atividade/tipo-atividade.module';
import {HomologacaoAtividadeComponent} from '../base/homologacao-atividade.component';
import {CadastroRapidoInstrutorComponent} from '../Componentes/cadastro-rapido-instrutor/cadastro-rapido-instrutor.component';
import {FuncaoExercidaComponent} from '../Componentes/funcao-exercida/funcao-exercida.component';
import {FileSizePipe} from '../util/file-size.pipe';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import { TableModule } from 'primeng/table'
import { CardModule } from 'primeng/card'
import { TermoAceiteLgpdComponent } from 'app/Componentes/termo-aceite-lgpd/termo-aceite-lgpd.component';
import { NomeDoMembroDaComissaoComponent } from 'app/Componentes/relatores-da-comissao/relatores-da-comissao.component';

@NgModule({
  imports: [
    CommonModule,
    FieldsetModule,
    GrowlModule,
    DataTableModule,
    DatatableModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MessagesModule,
    TextMaskModule,
    CalendarModule,
    AccordionModule,
    FieldsetModule,
    InputTextareaModule,
    DropdownModule,
    DataTableModule,
    FileUploadModule,
    DialogModule,
    ButtonModule,
    MultiSelectModule,
    EditorModule,
    RadioButtonModule,
    CheckboxModule,
    InputTextModule,
    StepsModule,
    DigitOnlyModule,
    TabViewModule,
    CurrencyMaskModule,
    InputSwitchModule,
    SliderModule,
    //ModulosModule,
  ],
  declarations: [
    base.BaseListFilterComponent,
    base.BaseListFilterAtividadeCapacitadoraComponent,
    base.BaseListFilterAtividadeProfissionalComponent,
    base.BaseListFilterHomologacaoProfisssionalComponent,
    base.BaseListFilterParticipantesPorEventoComponent,
    base.BaseListFilterParticipantesPorCursoComponent,
    FieldSetCapacitadoraComponent,
    CnpjMaskPipe,
    base.BaseInfoComponent,
    base.BaseComponent,
    base.BaseCrudComponent,
    base.BaseListComponent,
    base.BaseStepComponent,
    FormTextComponent,
    ValidationComponent,
    FormMaskTestComponent,
    BaseCrudNavigationComponent,
    CepMaskPipe,
    FormTextAreaComponent,
    FormatSelectItemPipe,
    SelectItemPipe,
    FormSelectComponent,
    NotificacaoAtividadesComponent,
    NotificacaoPrestacaoContasComponent,
    FormNumberComponent,
    FormMultiSelectComponent,
    FormEditorComponent,
    NoSanitizePipe,
    CpfMaskPipe,
    FormNumberCPFComponent,
    FormCalendarComponent,
    UnmaskDirective,
    ResumoHomologacaoComponent,
    NomeDoMembroDaComissaoComponent,
    ResumoJustificativaComponent,
    DecisaoDeJulgamentoComponent,
    DecisaoDeJulgamentoEventoIndividualComponent,
    PontuacaoHomologacaoComponent,
    CrudInstrutorEtapa1Component,
    GerenciarBancaEtapa1Component,
    GerenciarBancaEtapa2Component,
    GerenciamentoCursoExteriorEtapa1Component,
    GerenciamentoProducaoIntelectualEtapa1Component,
    ProfissionalGerenciarAtividadesComponent,
    FuncaoExercidaHomologacaoComponent,
    VisualizarAnexoComponent,
    UploadAnexosComponent,
    ViewRecursoComponent,
    AbrirRecursoComponent,
    EnviarRecursoComponent,
    ShowRecursoComponent,
    InterporRecursoComponent,
    UploadExcelComponent,
    FormNumberCPFComponent,
    FormNumberCEPComponent,
    FormNumberCNPJComponent,
    TelefoneComponent,
    TelefoneMaskPipe,
    FormCheckComponent,
    ResumoCursoComponent,
    ResumoEventoComponent,
    BaseHomologacaoComponent,
    ResumoDocenciaComponent,
    PontuacaoTotalResultadosComponent,
    NumRegistroMaskPipe,
    CrudGerenciamentoCapacitadoraComponent,
    CrudGerenciamentoCapacitadoraEtapa1Component,
    CrudGerenciamentoCapacitadoraEtapa2Component,
    FormMoneyComponent,
    FormHiddenComponent,
    FormSwitchComponent,
    FormRadioComponent,
    FormPercentComponent,
    FormSliderComponent,
    FormNumberRegistroComponent,
    FormHoraComponent,
    FormPercentIpcaComponent,
    TextBankAccountComponent,
    TextMaskBankComponent,
    HexadecimalValueValidator,
    HomologacaoAtividadeComponent,
    CadastroRapidoInstrutorComponent,
    FuncaoExercidaComponent,
    FileSizePipe,
    TermoAceiteLgpdComponent,

    //bloco relatorios
    CrudPrestacaoContaComponent,
    CrudPrestacaoContaEtapa1Component,
    CrudPrestacaoContaEtapa2Component,
    CrudPrestacaoContaEtapa3Component,
    FieldSetDadosProfissionalComponent,
    EnderecoComponent,
    TelefoneFormComponent,
    EmailComponent,
    DataTablePrestacaoContaComponent,
    GerenciamentoComissaoEtapa1Component,
    GerenciamentoComissaoEtapa2Component,
    GerenciamentoCursoExteriorEtapa2Component,
    GerenciamentoPosGraduacaoEtapa2Component,
    GerenciamentoProducaoIntelectualEtapa2Component,
    GerenciamentoPosGraduacaoEtapa1Component,

    //bloco gerenciamento curso, prestacao conta curso e turma e mais um monte de bagunça
    CrudCursoPrestacaoContaComponent,
    CrudCursoPrestacaoContaEtapa1Component,
    CrudCursoPrestacaoContaEtapa2Component,
    CrudCursoPrestacaoContaEtapa3Component,
    CrudCursoPrestacaoContaEtapa4Component,

    //especifico gerenciamento curso (...)
    CrudGerenciamentoCursoComponent,
    CrudGerenciamentoCursoEtapa1Component,
    CrudGerenciamentoCursoEtapa2Component,
    CrudGerenciamentoCursoEtapa3Component,
    CrudGerenciamentoCursoEtapa4Component,
    FormacaoAcademicaComponent,
    CrudFormacaoAcademicaComponent,
    CrudFormacaoAcademicaEtapa1Component,
    CrudFormacaoAcademicaEtapa2Component,
    CrudInstrutorComponent,
    CrudInstrutorEtapa2Component,
    InstrutorComponent,
    BaseCrudNavigationProfissionalComponent,

    //especifico gerenciamento evento (...)
    CrudEventoPrestacaoContaComponent,
    CrudEventoPrestacaoContaEtapa1Component,
    CrudEventoPrestacaoContaEtapa2Component,
    CrudEventoPrestacaoContaEtapa3Component,
    CrudEventoPrestacaoContaEtapa4Component,
    CrudEventoPrestacaoContaEtapa5Component,
    BtnDataTableBasisComponent,

    BasePrestacaoContaComponent,
    SelectItemPipe,
  ],
  exports: [
    base.BaseListFilterComponent,
    base.BaseListFilterAtividadeCapacitadoraComponent,
    base.BaseListFilterAtividadeProfissionalComponent,
    base.BaseListFilterHomologacaoProfisssionalComponent,
    base.BaseListFilterParticipantesPorEventoComponent,
    base.BaseListFilterParticipantesPorCursoComponent,
    FieldSetCapacitadoraComponent,
    CnpjMaskPipe,
    base.BaseInfoComponent,
    base.BaseComponent,
    base.BaseCrudComponent,
    base.BaseListComponent,
    base.BaseStepComponent,
    FormTextComponent,
    ValidationComponent,
    FormMaskTestComponent,
    BaseCrudNavigationComponent,
    CepMaskPipe,
    FormTextAreaComponent,
    FormatSelectItemPipe,
    SelectItemPipe,
    FormSelectComponent,
    NotificacaoAtividadesComponent,
    NotificacaoPrestacaoContasComponent,
    FormNumberComponent,
    FormMultiSelectComponent,
    FormEditorComponent,
    NoSanitizePipe,
    CpfMaskPipe,
    FormNumberCPFComponent,
    FormCalendarComponent,
    UnmaskDirective,
    PontuacaoHomologacaoComponent,
    ResumoHomologacaoComponent,
    NomeDoMembroDaComissaoComponent,
    ResumoJustificativaComponent,
    DecisaoDeJulgamentoComponent,
    DecisaoDeJulgamentoEventoIndividualComponent,
    PontuacaoHomologacaoComponent,
    CrudInstrutorEtapa1Component,
    GerenciarBancaEtapa1Component,
    GerenciarBancaEtapa2Component,
    GerenciamentoCursoExteriorEtapa1Component,
    GerenciamentoProducaoIntelectualEtapa1Component,
    ProfissionalGerenciarAtividadesComponent,
    FuncaoExercidaHomologacaoComponent,
    VisualizarAnexoComponent,
    UploadAnexosComponent,
    ViewRecursoComponent,
    AbrirRecursoComponent,
    EnviarRecursoComponent,
    ShowRecursoComponent,
    InterporRecursoComponent,
    UploadExcelComponent,
    FormNumberCPFComponent,
    FormNumberCEPComponent,
    FormNumberCNPJComponent,
    TelefoneComponent,
    TelefoneMaskPipe,
    FormCheckComponent,
    ResumoCursoComponent,
    ResumoEventoComponent,
    BaseHomologacaoComponent,
    ResumoDocenciaComponent,
    PontuacaoTotalResultadosComponent,
    NumRegistroMaskPipe,
    CrudGerenciamentoCapacitadoraComponent,
    CrudGerenciamentoCapacitadoraEtapa1Component,
    CrudGerenciamentoCapacitadoraEtapa2Component,
    GerenciamentoPosGraduacaoEtapa1Component,
    FormMoneyComponent,
    FormHiddenComponent,
    FormSwitchComponent,
    FormRadioComponent,
    FormPercentComponent,
    FormSliderComponent,
    FormNumberRegistroComponent,
    FormHoraComponent,
    FormPercentIpcaComponent,
    TextBankAccountComponent,
    TextMaskBankComponent,
    HexadecimalValueValidator,
    HomologacaoAtividadeComponent,
    CadastroRapidoInstrutorComponent,
    FuncaoExercidaComponent,
    FileSizePipe,
    TermoAceiteLgpdComponent,

    //bloco relatorios
    CrudPrestacaoContaComponent,
    CrudPrestacaoContaEtapa1Component,
    CrudPrestacaoContaEtapa2Component,
    CrudPrestacaoContaEtapa3Component,
    FieldSetDadosProfissionalComponent,
    EnderecoComponent,
    TelefoneFormComponent,
    EmailComponent,
    DataTablePrestacaoContaComponent,
    GerenciamentoComissaoEtapa1Component,
    GerenciamentoComissaoEtapa2Component,
    GerenciamentoCursoExteriorEtapa2Component,
    GerenciamentoPosGraduacaoEtapa2Component,
    GerenciamentoProducaoIntelectualEtapa2Component,

    //bloco gerenciamento curso, prestacao conta curso e turma e mais um monte de bagunça
    CrudCursoPrestacaoContaComponent,
    CrudCursoPrestacaoContaEtapa1Component,
    CrudCursoPrestacaoContaEtapa2Component,
    CrudCursoPrestacaoContaEtapa3Component,
    CrudCursoPrestacaoContaEtapa4Component,

    //especifico gerenciamento curso (...)
    CrudGerenciamentoCursoComponent,
    CrudGerenciamentoCursoEtapa1Component,
    CrudGerenciamentoCursoEtapa2Component,
    CrudGerenciamentoCursoEtapa3Component,
    CrudGerenciamentoCursoEtapa4Component,
    FormacaoAcademicaComponent,
    CrudFormacaoAcademicaComponent,
    CrudFormacaoAcademicaEtapa1Component,
    CrudFormacaoAcademicaEtapa2Component,
    CrudInstrutorComponent,
    CrudInstrutorEtapa2Component,
    InstrutorComponent,
    BaseCrudNavigationProfissionalComponent,

    //especifico gerenciamento evento (...)
    CrudEventoPrestacaoContaComponent,
    CrudEventoPrestacaoContaEtapa1Component,
    CrudEventoPrestacaoContaEtapa2Component,
    CrudEventoPrestacaoContaEtapa3Component,
    CrudEventoPrestacaoContaEtapa4Component,
    CrudEventoPrestacaoContaEtapa5Component,

    BtnDataTableBasisComponent,
    SelectItemPipe
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts